//Extras
import React, { useEffect, useState } from 'react'
import { main, fontType } from '../assets/extras'
import { getAge, getCurrentDate, validateEmail, validatePhone } from '../assets/validator'
import { useLocation, useParams } from 'react-router-dom'
import CryptoJS from 'crypto-js'

//Styles
import './styles/inscriptionForm.css'

//Connections
import { db } from '../assets/connections'
import { getDoc, doc, setDoc, addDoc, collection, getDocs, updateDoc } from 'firebase/firestore'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'

const PlayerSelfAdd = () => {

    const location = useLocation()
    
    const { ref } = useParams()

    const secretKey = 'MuBG7678bHJ$4eGr83&%'

    const [ variables, setVariables ] = useState({
        loading: true,
        nombreAcademia: "",
        ref: null,
        sedes: [],
        sedeDefault: "",
        sedeDefaultNombre: ""
    })

    //Datos del usuario
    const [ data, setData ] = useState({
        categoria_jugador: "",
        correo_jugador: "",
        edad_jugador: "",
        nivel_jugador: "",
        nombre_jugador: "",
        a_p: "",
        a_m: "",
        rama_jugador: "",
        telefono_jugador: "",
        clases_jugador: []
    })

    //Validador de los terminos y condiciones
    const [ checked, setChecked ] = useState(false)
    
    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
                            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #56d600;'></div>"
                          : status == "warning" ?
                            "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                          : status == "error" ?
                            "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #c20000;'></div>"
                          : ""
        
        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que envia el mensaje por correo
    const sendMessage = async () => {
        await fetch("https://us-central1-tenistapp2000.cloudfunctions.net/correoBienvenida", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                correo: data.correo_jugador,
                nombre: data.nombre_jugador
            }),
        }).then((success) => {
            console.log(success)
        }).catch((error) => {
            console.log(error)
        })
    }

    //Funcion al hacer clic en el boton de guardar
    const onHandleGuardar = () => {
        if(data.nombre_jugador && data.a_p && data.telefono_jugador && data.rama_jugador && data.edad_jugador){
            if(getAge(data.edad_jugador) <= 12){
                if(validatePhone(data.telefono_jugador)){
                    if(checked == true){
                        //Aqui se manda la informacion a la base de datos
                        setVariables(prev => ({
                            ...prev, 
                            loading: true
                        }))
                        loadingData()
                    } else {
                        showMessage("Debes aceptar los terminos y condiciones", "warning")
                    }
                } else {
                    showMessage("Telefono invalido", "warning")
                }
            } else {
                if(data.correo_jugador){
                    if(validateEmail(data.correo_jugador)){
                        if(validatePhone(data.telefono_jugador)){
                            if(checked == true){
                                //Aqui se manda la informacion a la base de datos
                                //Aqui se manda la informacion a la base de datos
                                setVariables(prev => ({
                                    ...prev, 
                                    loading: true
                                }))
                                loadingData()
                            } else {
                                showMessage("Debes aceptar los terminos y condiciones", "warning")
                            }
                        } else {
                            showMessage("Telefono invalido", "warning")
                        }
                    } else {
                        showMessage("Correo invalido", "warning")
                    }
                } else {
                    showMessage("Debes ingresar un correo", "warning")
                }
            }
        } else {
            showMessage("Debes completar todos los campos.", "warning")
        }
    }

    //Funcion que carga los datos a la bd 
    const loadingData = async () => {
        if(data.correo_jugador){
            getPlayer()
        } else {
            loadDataSNCorreo()
        }
    }
    //Funcion que valida si el jugador esta en la base de datos de una academia
    const getPlayer = async () => {
        await getDoc(doc(doc(db, variables.ref), "Jugador", data.correo_jugador)).then(r => {
            if(r.exists()){
                //Aqui se manda la informacion a la base de datos
                setVariables(prev => ({
                    ...prev, 
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("El jugador ya esta registrado en la academia", "warning")
                }, 100)
            } else {
                loadData()
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev, 
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    //Funcion que sube los datos del jugador a la base de datos
    const loadData = async () => {
        const edadAux = getAge(data.edad_jugador)

        const newData = {
            asistencias: [],
            categoria_jugador: edadAux > 0 && edadAux <= 8 ? "Infantil 4 a 8 años" :
                               edadAux > 8 && edadAux <= 12 ? "Infantil 8 a 12 años" :
                               edadAux > 12 &&  edadAux < 18 ? "Juvenil 12 a 18 años" :
                               edadAux > 18 ? "Adultos" : "",
            clases_jugador: data.clases_jugador,
            correo_jugador: data.correo_jugador,
            edad_jugador: data.edad_jugador,
            suscripciones_jugador: [
                {
                    suscripcion: "Inscripcion",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                },
                {
                    suscripcion: "Mensualidad",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                }
            ],
            nivel_jugador: "",
            nombre_jugador: data.nombre_jugador + " " + data.a_p + " " + (data.a_m ? data.a_m : ""),
            rama_jugador: data.rama_jugador,
            ranking_jugador: 0,
            telefono_jugador: data.telefono_jugador,
            ultima_asistencia: "0000-00-00",
            fecha_alta: getCurrentDate(),
            fecha_baja: "----/--/--",
            sede_default: variables.sedeDefault || "",
            nombre_sede_default: variables.sedeDefaultNombre || ""
        }

        await setDoc(doc(doc(db, variables.ref), "Jugador", newData.correo_jugador), newData).then(async r => {
            await sendMessage()
            setData({
                categoria_jugador: "",
                correo_jugador: "",
                edad_jugador: "",
                nivel_jugador: "",
                nombre_jugador: "",
                a_p: "",
                a_m: "",
                rama_jugador: "",
                telefono_jugador: "",
                clases_jugador: []
            })
            setVariables(prev => ({
                ...prev, 
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugador registrado correctamente", "success")
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev, 
                loading: false
            }))
        })
    }
    //Funcion que sube los datos del jugador sin  correo
    const loadDataSNCorreo = async (ref) => {
        const edadAux = getAge(data.edad_jugador)
        const newData = {
            asistencias:[],
            asistencias_jugador: [],
            categoria_jugador: edadAux > 0 && edadAux <= 8 ? "Infantil 4 a 8 años" :
                               edadAux > 8 && edadAux <= 12 ? "Infantil 8 a 12 años" :
                               edadAux > 12 &&  edadAux < 18 ? "Juvenil 12 a 18 años" :
                               edadAux > 18 ? "Adultos" : "",
            clases_jugador: data.clases_jugador,
            correo_jugador: "",
            edad_jugador: data.edad_jugador,
            sede_default: variables.sedeDefault || "",
            nombre_sede_default: variables.sedeDefaultNombre || "",
            suscripciones_jugador: [
                {
                    suscripcion: "Inscripcion",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                },
                {
                    suscripcion: "Mensualidad",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                }
            ],
            nivel_jugador: "",
            nombre_jugador: data.nombre_jugador + " " + data.a_p + " " + (data.a_m ? data.a_m : ""),
            rama_jugador: data.rama_jugador,
            ranking_jugador: 0,
            telefono_jugador: data.telefono_jugador,
            ultima_asistencia: "0000-00-00",
            fecha_alta: getCurrentDate(),
            fecha_baja: "----/--/--"
        }

        await addDoc(collection(doc(db, variables.ref), "Jugador"), newData).then(r => {
            setEmailValue(r.id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev, 
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    //Funcion que da el valor del correo aleatorio
    const setEmailValue = async (id) => {
        await updateDoc(doc(doc(db, variables.ref), "Jugador", id), {
            correo_jugador: id
        }).then(async r => {
            await sendMessage()
            setData({
                categoria_jugador: "",
                correo_jugador: "",
                edad_jugador: "",
                nivel_jugador: "",
                nombre_jugador: "",
                a_p: "",
                a_m: "",
                rama_jugador: "",
                telefono_jugador: "",
                clases_jugador: []
            })

            setVariables(prev => ({
                ...prev, 
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugador registrado correctamente", "success")
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev, 
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    const decodeRef = async () => {

        const refCode = ref.replace(/_/g, '/').replace(/-/g, '+')
        const decodedRef = CryptoJS.AES.decrypt(refCode, secretKey).toString(CryptoJS.enc.Utf8)
        const refPath = decodedRef.split("|")[0]
        const nombreAcademia = decodedRef.split("|")[1]

        // Cargar sedes activas
        var sedeDefault = ""
        var sedeDefaultNombre = ""
        var sedesAux = []
        try {
            const sedesSnap = await getDocs(collection(doc(db, refPath), "Sedes"))
            sedesAux = sedesSnap.docs
                .filter(s => s.data().activa !== false)
                .map(s => ({ id: s.id, nombre_sede: s.data().nombre_sede, es_default: s.data().es_default || false }))
            const defaultSede = sedesAux.find(s => s.es_default) || sedesAux[0]
            if (defaultSede) {
                sedeDefault = defaultSede.id
                sedeDefaultNombre = defaultSede.nombre_sede
            }
        } catch(e) {
            console.error("Error cargando sedes:", e)
        }

        setVariables(prev => ({
            ...prev,
            ref: refPath,
            nombreAcademia: nombreAcademia,
            sedes: sedesAux,
            sedeDefault: sedeDefault,
            sedeDefaultNombre: sedeDefaultNombre,
            loading: false
        }))

    }

    useEffect(() => {
        document.title = "Registro"

        decodeRef()
    }, [])

    if(variables.loading)
    return (
        <Loader loading={variables.loading} />
    )

    if(!variables.loading && ref)
    return (
        <div style={{
            flex: 1,
            marginBottom: 100
        }}>

            <Snack />

            <div style={{
                backgroundColor: main,
                width: "100%",
                height: 80,
                display: "flex ",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <h1 style={{
                    fontFamily: fontType.title,
                    color: "white",
                }}>{variables.nombreAcademia ? variables.nombreAcademia : "REGISTRO DE DATOS"}</h1>
            </div>

            <div className="cont11">
                <div className='cont'>
                    <h2 style={{ fontFamily: fontType.subTitle }}>DATOS PERSONALES</h2>
                    <div className='contInput'>
                        <p style={{ fontFamily: fontType.subTitle }}>Nombre</p>
                        <input style={{ fontFamily: fontType.text }}
                            onChange={e => setData({ ...data, nombre_jugador: e.target.value })}
                            value={data.nombre_jugador}
                            maxLength={30}
                            placeholder='Nombre(s)'
                        />
                    </div>
                    <div className='contInput'>
                        <p style={{ fontFamily: fontType.subTitle }}>Apellido paterno</p>
                        <input style={{ fontFamily: fontType.text }}
                            onChange={e => setData({ ...data, a_p: e.target.value })}
                            value={data.a_p}
                            maxLength={30}
                        />
                    </div>
                    <div className='contInput'>
                        <p style={{ fontFamily: fontType.subTitle }}>Apellido materno</p>
                        <input style={{ fontFamily: fontType.text }} placeholder="(Opcional)"
                            onChange={e => setData({ ...data, a_m: e.target.value })}
                            value={data.a_m}
                            maxLength={30}
                        />
                    </div>
                    <div className='contInput'>
                        <p style={{ fontFamily: fontType.subTitle }}>Telefono</p>
                        <input style={{ fontFamily: fontType.text }}
                            placeholder='10 Digitos (ej. 5543657452)'
                            onChange={e => setData({ ...data, telefono_jugador: e.target.value.replace(" ", "") })}
                            value={data.telefono_jugador}
                            maxLength={10}
                        />
                    </div>
                    <div className='contInput'>
                        <p style={{ fontFamily: fontType.subTitle }}>Fecha de nacimiento</p>
                        <input style={{ fontFamily: fontType.text }} type="date"
                            onChange={e => setData({ ...data, edad_jugador: e.target.value })}
                            value={data.edad_jugador}
                        />
                    </div>
                    {
                        data.edad_jugador ?
                            getAge(data.edad_jugador) > 12 ?
                                <div className='contInput'>
                                    <p style={{ fontFamily: fontType.subTitle }}>Correo</p>
                                    <input style={{ fontFamily: fontType.text }}
                                        onChange={e => setData({ ...data, correo_jugador: e.target.value.replace(" ", "").toLowerCase() })}
                                        value={data.correo_jugador}
                                        maxLength={50}
                                        placeholder={'ejemplo@gmail.com'}

                                    />
                                </div>
                                : null
                            :
                            null
                    }
                </div>
            </div>

            <div className='cont' style={{
                width: "100%"
            }}>

                <h2 style={{ fontFamily: fontType.subTitle }}>DATOS DEPORTIVOS</h2>

                <div className='contSportData'>
                    <div className='contSelect'>
                        <p style={{ fontFamily: fontType.subTitle }}>Rama</p>
                        <select id="rama" style={{ fontFamily: fontType.subTitle }}
                            onChange={e => setData({ ...data, rama_jugador: e.target.value })}
                            value={data.rama_jugador}
                        >
                            <option value=""></option>
                            <option value="Varonil">Varonil</option>
                            <option value="Femenil">Femenil</option>
                        </select>
                    </div>
                    {variables.sedes.length > 1 && (
                        <div className='contSelect'>
                            <p style={{ fontFamily: fontType.subTitle }}>Sede</p>
                            <select style={{ fontFamily: fontType.subTitle }}
                                value={variables.sedeDefault}
                                onChange={e => {
                                    const sede = variables.sedes.find(s => s.id === e.target.value)
                                    setVariables(prev => ({
                                        ...prev,
                                        sedeDefault: e.target.value,
                                        sedeDefaultNombre: sede ? sede.nombre_sede : ""
                                    }))
                                }}
                            >
                                {variables.sedes.map(s => (
                                    <option key={s.id} value={s.id}>{s.nombre_sede}</option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>

                <div className="contCheckbox" style={{
                    width: "70%"
                }}>
                    <input type='checkbox' value={checked} onChange={e => setChecked(!checked)} />
                    <p style={{ fontFamily: fontType.text }}>He leido y acepto los
                        <a href='/terms' target='_blank'> terminos y condiciones</a>
                    </p>
                </div>

                <div style={{
                    width: "60%",
                    maxWidth: 300,
                    minWidth: 200,
                    marginTop: 50
                }}>
                    <button style={{
                        fontFamily: fontType.title,
                        backgroundColor: main,
                        width: "100%"
                    }}

                        onClick={onHandleGuardar}>GUARDAR</button>
                </div>
            </div>
        </div>
    )
}

export default PlayerSelfAdd